import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _excluded = ["style", "className", "children", "item", "index"];
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { forwardRef } from 'react';
import { useStyles, StyleSheet, StylesProvider, padding, margin } from '@rexlabs/styling';
import Icons from '@rexlabs/icons';
import { Checkbox } from '@rexlabs/checkbox';
import { HoverContainer } from '../hover-container';
import { useSelect } from '../../hooks/use-select';
var Check = Icons.Check;
var defaultStyles = StyleSheet({
  check: _objectSpread({}, margin.styles({
    target: 'select.option.check',
    left: 'xs'
  })),
  checkbox: {
    // We don't want to disable the input but we also
    // don't want the user to click on it because the
    // event propagation seems to be a bit funky
    // and messes something up leading to an error
    pointerEvents: 'none'
  }
});
var checkboxOverrides = {
  checkbox: {
    container: _objectSpread({}, padding.tokens({
      y: 'none'
    }))
  }
};
export var OptionContainer = /*#__PURE__*/forwardRef(function OptionContainer(_ref, ref) {
  var style = _ref.style,
      className = _ref.className,
      children = _ref.children,
      item = _ref.item,
      index = _ref.index,
      props = _objectWithoutProperties(_ref, _excluded);

  var s = useStyles(defaultStyles);

  var _useSelect = useSelect(),
      multi = _useSelect.multi,
      selectedItem = _useSelect.selectedItem,
      selectedItems = _useSelect.selectedItems,
      getItemId = _useSelect.getItemId;

  var isSelected = multi ? !!_findInstanceProperty(selectedItems).call(selectedItems, function (selectedItem) {
    return getItemId(selectedItem) === getItemId(item);
  }) : selectedItem ? getItemId(selectedItem) === getItemId(item) : false;
  return /*#__PURE__*/React.createElement(HoverContainer, _extends({}, props, s.with('container')({
    style: style,
    className: className
  }), {
    ref: ref,
    index: index
  }), children, !multi ? isSelected ? /*#__PURE__*/React.createElement(Check, _extends({}, s('check'), {
    size: "m"
  })) : null : /*#__PURE__*/React.createElement(StylesProvider, {
    tokens: checkboxOverrides
  }, /*#__PURE__*/React.createElement(Checkbox, _extends({}, s('check', 'checkbox'), {
    value: isSelected // Don't allow the the checkbox to be tabbed to
    ,
    tabIndex: -1
  }))));
});